import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import IngresoNuevaMatricula, { ProcesoState, ProcesoStateInicial } from '.';
import { fechaActual } from '../comun/utils/fechaActual';

type ProcesoStateDesdeAlmacenado = RouteComponentProps<{}, {}, ProcesoState | undefined>;

class IngresoNuevaMatriculaConURLState extends React.PureComponent<ProcesoStateDesdeAlmacenado> {
    private readonly procesoState: ProcesoStateInicial | undefined;

    public constructor(props: ProcesoStateDesdeAlmacenado) {
        super(props);

        if (this.props.location.state) {
            const transformarAlumno = (alumno: ProcesoState['alumnos']['alumnoPrincipal']) => {
                return {
                    ...alumno,
                    numeroMatricula: undefined!,
                    matricula: {
                        ...alumno.matricula,
                        fechaContrato: fechaActual(),
                    },
                };
            };

            // Se utiliza cualquier valor comenzando con _. No tienen ninguna otra utilidad mas que
            // evitar la advertencia, ya que se usó para extraerlos del state y que no estuvieran
            // ahi, no para usarlos
            const {
                id: _1,
                tieneFirmas: _2,
                tieneFotocopias: _3,
                tieneHuellas: _4,
                ...state
            } = this.props.location.state;
            this.procesoState = {
                ...state,
                numeroPagare: undefined,
                alumnos: {
                    alumnoPrincipal: transformarAlumno(state.alumnos.alumnoPrincipal),
                    otrosAlumnos: state.alumnos.otrosAlumnos.map(transformarAlumno),
                },
            };
        }
    }

    public render() {
        return (
            <div>
                <IngresoNuevaMatricula stateInicial={this.procesoState} />
            </div>
        );
    }
}

export default IngresoNuevaMatriculaConURLState;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/IngresoNuevaMatriculaConURLState.tsx